<section class="asst" id="assistant">
  <div class="wrap">
    <div class="asst-grid">
      <!-- left -->
      <div>
        <span class="asst-badge" appReveal
          ><svg viewBox="0 0 24 24" fill="none">
            <path
              d="M12 2l1.8 5.2L19 9l-5.2 1.8L12 16l-1.8-5.2L5 9l5.2-1.8L12 2z"
              fill="currentColor"
            />
          </svg>
          AI Personal Assistant</span
        >
        <h2 appReveal>
          Your AI Assistant,<br /><span class="hl"
            >always working for you.</span
          >
        </h2>
        <p class="lead" appReveal>
          Your intelligent AI representative that answers questions, schedules
          meetings, captures opportunities and connects people to you — 24/7.
        </p>
        <ul class="asst-feats">
          <li class="asst-feat" appReveal>
            <span class="ic"
              ><svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path
                  d="M4 5h16v11H8l-4 3V5z"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linejoin="round"
                />
                <path
                  d="M9 10h6M9 13h3"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                /></svg
            ></span>
            <div>
              <h4>Answers Questions</h4>
              <p>Instant, accurate responses based on your knowledge.</p>
            </div>
          </li>
          <li class="asst-feat" appReveal>
            <span class="ic"
              ><svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <rect
                  x="3"
                  y="5"
                  width="18"
                  height="16"
                  rx="2"
                  stroke="currentColor"
                  stroke-width="1.8"
                />
                <path
                  d="M3 9h18M8 3v4M16 3v4"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                /></svg
            ></span>
            <div>
              <h4>Schedules Meetings</h4>
              <p>Handles calendar, availability and confirmations.</p>
            </div>
          </li>
          <li class="asst-feat" appReveal>
            <span class="ic"
              ><svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path
                  d="M8 7a3 3 0 116 0 3 3 0 01-6 0zM2 21a6 6 0 0112 0M15 8a3 3 0 010 6M16 21a6 6 0 015-6"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                /></svg
            ></span>
            <div>
              <h4>Captures Opportunities</h4>
              <p>Qualifies leads and gathers key information.</p>
            </div>
          </li>
          <li class="asst-feat" appReveal>
            <span class="ic"
              ><svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path
                  d="M15 8l5-3v14l-5-3M3 6h12v12H3z"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linejoin="round"
                /></svg
            ></span>
            <div>
              <h4>Escalates to You</h4>
              <p>Seamless handoff via chat, voice or video.</p>
            </div>
          </li>
          <li class="asst-feat" appReveal>
            <span class="ic"
              ><svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path
                  d="M4 5a2 2 0 012-2h11a1 1 0 011 1v15a1 1 0 01-1 1H6a2 2 0 01-2-2V5z"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linejoin="round"
                />
                <path
                  d="M4 17.5A2 2 0 016 16h12"
                  stroke="currentColor"
                  stroke-width="1.8"
                /></svg
            ></span>
            <div>
              <h4>Knows Your World</h4>
              <p>Trained on your profile, documents and preferences.</p>
            </div>
          </li>
        </ul>
      </div>

      <!-- right visual -->
      <div class="asst-visual" appReveal>
        <!-- <div class="a-card a-greet">
          <div class="hi">Hello! 👋</div>
          <p>I'm your AI Assistant. How can I help you today?</p>
          <div class="a-input">
            <span>Ask me anything…</span>
            <span class="a-send"
              ><svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M4 12l16-8-6 16-2-6-8-2z" fill="currentColor" /></svg
            ></span>
          </div>
        </div> -->
        <div class="a-card a-row">
          <span class="ric"
            ><svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <rect
                x="3"
                y="5"
                width="18"
                height="16"
                rx="2"
                stroke="#fff"
                stroke-width="1.8"
              />
              <path
                d="M3 9h18M8 3v4M16 3v4"
                stroke="#fff"
                stroke-width="1.8"
                stroke-linecap="round"
              /></svg
          ></span>
          <div>
            <h5>Schedule a Meeting</h5>
            <p>Book a time that works for you</p>
            <!-- <div class="meta">10:30 AM, May 20</div> -->
          </div>
        </div>
        <div class="a-card a-row">
          <span class="ric"
            ><svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path
                d="M4 5h16v11H8l-4 3V5z"
                stroke="#fff"
                stroke-width="1.8"
                stroke-linejoin="round"
              /></svg
          ></span>
          <div>
            <h5>Ask a Question</h5>
            <p>Get instant answers</p>
            <!-- <div class="meta">About services, pricing, etc.</div> -->
          </div>
        </div>
        <div class="a-card a-row">
          <span class="ric"
            ><svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="8" r="4" stroke="#fff" stroke-width="1.8" />
              <path
                d="M5 21a7 7 0 0114 0"
                stroke="#fff"
                stroke-width="1.8"
                stroke-linecap="round"
              /></svg
          ></span>
          <div>
            <h5>Connect with Me</h5>
            <p>Request a call or video meeting</p>
            <!-- <div class="meta">Let's talk →</div> -->
          </div>
        </div>
        <!-- <div class="a-qr">
          <div class="qr">
            <svg viewBox="0 0 100 100" shape-rendering="crispEdges">
              <rect width="100" height="100" fill="#fff" />
              <path
                fill="#0C0E14"
                d="M0 0h30v30H0zM10 10h10v10H10zM70 0h30v30H70zM80 10h10v10H80zM0 70h30v30H0zM10 80h10v10H10zM40 0h10v10H40zM55 0h10v10H55zM40 15h10v10H40zM60 20h10v10H60zM0 40h10v10H0zM15 40h10v10H15zM25 50h10v10H25zM0 55h10v10H0zM40 40h10v10H40zM55 45h10v10H55zM70 40h10v10H70zM85 45h10v10H85zM40 60h10v10H40zM55 65h15v10H55zM75 60h10v10H75zM90 65h10v10H90zM45 80h10v10H45zM60 85h10v10H60zM75 80h10v10H75zM85 90h10v10H85z"
              />
            </svg>
          </div>
          <div class="qt">
            Your AI Assistant.<br /><b>One Link. One QR Code.</b><br />Endless
            Possibilities.
          </div>
        </div> -->
        <div class="channels" appReveal>
          <div class="ttl">Available on your preferred channels</div>
          <div class="channels-row">
            <div class="channel">
              <span class="cic"
                ><svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M4 5h16v11H8l-4 3V5z"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linejoin="round"
                  /></svg></span
              ><span>Web Chat</span>
            </div>
            <div class="channel">
              <span class="cic"
                ><svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M5 4h4l2 5-3 2a11 11 0 005 5l2-3 5 2v4a2 2 0 01-2 2A16 16 0 013 6a2 2 0 012-2z"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linejoin="round"
                  /></svg></span
              ><span>Voice Call</span>
            </div>
            <div class="channel">
              <span class="cic"
                ><svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M15 8l5-3v14l-5-3M3 6h12v12H3z"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linejoin="round"
                  /></svg></span
              ><span>Video Call</span>
            </div>
            <!-- <div class="channel">
              <span class="cic"
                ><svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12 3a9 9 0 00-7.7 13.6L3 21l4.5-1.2A9 9 0 1012 3z"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9 9c0 4 2 6 6 6"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linecap="round"
                  /></svg></span
              ><span>WhatsApp</span>
            </div> -->
            <div class="channel">
              <span class="cic"
                ><svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M4 5h16v12H7l-3 3V5z"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linejoin="round"
                  /></svg></span
              ><span>SMS</span>
            </div>
            <div class="channel">
              <span class="cic"
                ><svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <rect
                    x="3"
                    y="5"
                    width="18"
                    height="14"
                    rx="2"
                    stroke="currentColor"
                    stroke-width="1.8"
                  />
                  <path
                    d="M4 7l8 6 8-6"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linejoin="round"
                  /></svg></span
              ><span>Email</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- stats strip -->
    <div class="asst-stats" appReveal>
      <div class="a-stat">
        <span class="sic"
          ><svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <circle
              cx="12"
              cy="12"
              r="9"
              stroke="currentColor"
              stroke-width="1.8"
            />
            <path
              d="M12 7v5l3 2"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
            /></svg
        ></span>
        <div><b>24/7</b><span>Always Available</span></div>
      </div>
      <div class="a-stat">
        <span class="sic"
          ><svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M13 2L3 14h7l-1 8 10-12h-7l1-8z"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linejoin="round"
            /></svg
        ></span>
        <div><b>Instant</b><span>Quick Responses</span></div>
      </div>
      <div class="a-stat">
        <span class="sic"
          ><svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <circle
              cx="12"
              cy="8"
              r="4"
              stroke="currentColor"
              stroke-width="1.8"
            />
            <path
              d="M5 21a7 7 0 0114 0"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
            /></svg
        ></span>
        <div><b>Personalized</b><span>Trained Just for You</span></div>
      </div>
      <div class="a-stat">
        <span class="sic"
          ><svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6l8-3z"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linejoin="round"
            />
            <path
              d="M9 12l2 2 4-4"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
              stroke-linejoin="round"
            /></svg
        ></span>
        <div><b>Secure</b><span>Your Data is Protected</span></div>
      </div>
      <div class="a-stat">
        <span class="sic"
          ><svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M4 9l4-4 4 4M8 5v9M20 15l-4 4-4-4M16 19v-9"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            /></svg
        ></span>
        <div><b>Seamless</b><span>Works Across Platforms</span></div>
      </div>
    </div>
  </div>
</section>
